import { Card, Container, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import TablePermissionControlScreen from 'src/component-project/PermissionControlPages/TablePermissionControlScreen';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import AddButton from 'src/components/Button.js/AddBotton';
import Loader from 'src/components/loader/loader';
import CreateScreenModal from 'src/components/modal/CreateScreenModal';
import { sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';

const ListScreenPermissionPage = () => {
    const { t } = useTranslation();
    const params = useParams();
    const [tableData, setTableData] = useState([]);
    const [getFlags, setGetFlags] = useState(false);
    const getRef = useRef(false);

    const [valueUser, setValueUser] = useState('1');

    const [visibleCreateScreen, setVisibleCreateScreen] = useState(false);

    const [tableDataScreenGroup, setTableDataScreenGroup] = useState([]);
    const [getFlagsScreenGroup, setGetFlagsScreenGroup] = useState(false);
    const getRefScreenGroup = useRef(false);

    // const searchValueDeboun = useRef('');
    // const throttled = useRef(debounce(() => getData(), 1000));

    const [loading, setLoading] = useState(false);

    const screenPermissions = useRef({});
    const user = useRef({});

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
        const menu = sessionStorage.getItem('menu');
        if (menu) {
            try {
                const data = JSON.parse(crypt.deCode(menu));
                // console.log('Loading menu', data[0]);
                screenPermissions.current = data[0].filter((item) => item.screens_key === 'phan_quyen_nguoi_dung')[0];
                // console.log('screenPermissions', screenPermissions);
            } catch (error) {}
        }
    }, []);

    useEffect(() => {
        setValueUser('1');
        // setTimeout(() => {
        //     getData();
        // }, 1000);
    }, []);

    useEffect(() => {
        if (valueUser) {
            setTimeout(() => {
                getDataScreenGroup(valueUser);
            }, 500);
        }
    }, [valueUser]);

    // const getData = () => {
    //     if (getRef.current) {
    //         return;
    //     }
    //     getRef.current = true;
    //     const InVal = [
    //         99999999, searchValueDeboun.current
    //     ];
    //     sendRequest(serviceList.getAllScreen, InVal, getDataResult, true, timeOutFunct, 40000);
    // };

    // const getDataResult = (reqInfoMap, message) => {
    //     getRef.current = false;
    //     setGetFlags(false);
    //     if (message['proc_status'] === "0") {
    //         toast.error('Error: ' + message['proc_message']);
    //         return;
    //     } else {
    //         console.log(message.proc_data.rows)
    //         setTableData(message.proc_data.rows[0].o_1);
    //         // console.log("GetDataResult", valueUser)
    //         // if (valueUser) {
    //         //     setTimeout(() => {
    //         //         getDataScreenGroup(valueUser);
    //         //     }, 500);
    //         // }
    //     }
    // };

    // const timeOutFunct = (reqInfo) => {
    //     getRef.current = false;
    //     setGetFlags(false);
    // };

    const getDataScreenGroup = (valueUser) => {
        if (getRefScreenGroup.current) {
            return;
        }
        getRefScreenGroup.current = true;
        setLoading(true);
        const InVal = [valueUser, '', 99999999];
        sendRequest(
            serviceList.getListScreenGroup,
            InVal,
            getDataResultScreenGroup,
            true,
            timeOutFunctScreenGroup,
            40000
        );
    };

    const getDataResultScreenGroup = (reqInfoMap, message) => {
        getRefScreenGroup.current = false;
        setGetFlagsScreenGroup(false);
        setLoading(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            // const mergedArray = tableData.map((item1) => {
            //     const matchingItem = data.find((item2) => (item2.screen_id === item1.id));
            //     if (matchingItem) {
            //         return {
            //             ...item1,
            //             user_type: matchingItem.user_type,
            //             search: matchingItem.search,
            //             insert: matchingItem.insert,
            //             update: matchingItem.update,
            //             delete: matchingItem.delete,
            //             block: matchingItem.block,
            //             import: matchingItem.import,
            //             export: matchingItem.export,
            //         };
            //     }
            //     return item1;
            // });
            // console.log(data, mergedArray);
            setTableDataScreenGroup(data);
        }
    };

    const timeOutFunctScreenGroup = (reqInfo) => {
        getRefScreenGroup.current = false;
        setGetFlagsScreenGroup(false);
        setLoading(false);
    };

    const handleChangeUser = (event) => {
        setValueUser(event.target.value);
    };

    // const searchValue = (value) => {
    //     if (!value) {
    //         value = '';
    //     }
    //     searchValueDeboun.current = value;
    //     // setvalueSearch(value);
    //     throttled.current();
    // };

    return (
        <>
            <Helmet>
                <title> {t('quan_ly_man_hinh')} </title>
            </Helmet>
            <CreateScreenModal
                visible={visibleCreateScreen}
                setVisible={setVisibleCreateScreen}
                fuctGet={getDataScreenGroup}
            />
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('quan_ly_man_hinh')}
                    </Typography>
                </Stack>{' '}
                <Breadcrumb
                    paths={[
                        {
                            label: t('phan_quyen_nguoi_dung'),
                            url: `/home/decentralization/${params.idPermission}`,
                            navigate: false,
                        },
                        { label: t('quan_ly_man_hinh'), url: '#', navigate: false },
                    ]}
                />
                <Loader loading={loading} />
                <Card>
                    <Stack sx={{ paddingTop: 1, paddingLeft: 4 }}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={valueUser}
                            onChange={handleChangeUser}
                        >
                            <FormControlLabel value="1" control={<Radio />} label={t('administrator')} />
                            <FormControlLabel value="2" control={<Radio />} label={t('manager')} />
                            <FormControlLabel value="3" control={<Radio />} label={t('staff')} />
                            <FormControlLabel value="4" control={<Radio />} label={t('approval')} />
                        </RadioGroup>
                    </Stack>
                    <TablePermissionControlScreen
                        tableData={valueUser ? tableDataScreenGroup : tableData}
                        fuctGet={getDataScreenGroup}
                        valueUser={valueUser}
                        fuctGetDataScreenGroup={getDataScreenGroup}
                        // searchValue={searchValue}
                    />
                </Card>
            </Container>
            {user.current?.group_user === '1' && <AddButton onClick={() => setVisibleCreateScreen(true)} />}
        </>
    );
};

export default ListScreenPermissionPage;
